var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8111413_rightlinearrow_right_arrow_direction_arrows_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 36.4102L6.09374 23.0039L7.70859 21.3883L18.3574 32.0379L18.3574 2.58984L20.6426 2.58984L20.6426 32.0379L31.2944 21.3853L32.9062 23.0039L19.5 36.4102Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDownArrow);
export default __webpack_public_path__ + "static/media/white-down-arrow.ad24d4babfb9ad1294960b0db78efc1c.svg";
export { ForwardRef as ReactComponent };